import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";

import styles from './CustomPackageOrderPage.module.scss';
import {stepperInfoActions} from "../../../store/slices/stepperInfoSlice";
import SpringCleaning from "../../../components/SpringCleaning/SpringCleaning";
import CleanWindows from "../../../components/CleanWindows/CleanWindows";
import AdditionalServices from "../../../components/AdditionalServices/AdditionalServices";
import AddPhoto from "../../../components/AddPhoto/AddPhoto";
import SquareApartmentInput from "../../../components/SquareApartmentInput/SquareApartmentInput";
import TypeCleaning from "../../../components/TypeCleaning/TypeCleaning";
import OfferedPriceCustomer from "../../../components/OfferedPriceCustomer/OfferedPriceCustomer";

const CustomPackageOrderPage = ({setCurrentStep}) => {
    const dispatch = useDispatch();
    const {
        typeBuilding,
        type_cleaning,
        finalPrice,
    } = useSelector(state => state.stepperInfo);

    useEffect(() => {
        if (!type_cleaning && !typeBuilding) {
            dispatch(stepperInfoActions.setTypeCleaning('Генеральне'));
            dispatch(stepperInfoActions.setTypeBuilding('Квартира'));
        }
    }, [])

    const handleSelectTypeBuilding = (building) => {
        dispatch(stepperInfoActions.setTypeBuilding(building));
    }

    return (
        <div className={styles.customPackageOrder_wrapper}>
            <div className={styles.customPackageOrder_wrapper_typeBuilding}>
                <button
                    className={`${styles.customPackageOrder_wrapper_typeBuilding_button}
                    ${typeBuilding === 'Квартира' ? styles.selected : ''}`}
                    onClick={() => handleSelectTypeBuilding('Квартира')}
                >Квартира
                </button>
                <button
                    className={`${styles.customPackageOrder_wrapper_typeBuilding_button}
                    ${typeBuilding === 'Будинок' ? styles.selected : ''}`}
                    onClick={() => handleSelectTypeBuilding('Будинок')}
                >Будинок
                </button>
                <button
                    className={`${styles.customPackageOrder_wrapper_typeBuilding_button} 
                    ${typeBuilding === 'Комерція' ? styles.selected : ''}`}
                    onClick={() => handleSelectTypeBuilding('Комерція')}
                >Комерція
                </button>
            </div>

            <SquareApartmentInput/>
            <TypeCleaning/>
            {type_cleaning === 'Генеральне' && <>
                <SpringCleaning/>
                <CleanWindows/>
            </>}
            {type_cleaning === 'Миття вікон' && <CleanWindows/>}
            <AdditionalServices/>
            <OfferedPriceCustomer minPrice={finalPrice}/>
            <AddPhoto setCurrentStep={setCurrentStep}/>
        </div>
    );
};

export default CustomPackageOrderPage;
